import { getData, postData, putData } from "../../../services/api"

export const getStock = async (q, l, sum, branchsNo, page, rowsPerPage) => {
    let _params = `&${q ? 'name=' + q + '&' : ''}${l ? l !== 'all' ? 'lot=' + l + '&' : '' : ''}${sum ? 'sumLots=' + sum : ''}`

    const res = await getData(`stock/branchs/${branchsNo}/lots?page=${page}&limit=${rowsPerPage}${_params}`)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const getBranchList = async () => {
    const res = await getData('dbms/branchs')
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const getZones = async (BranchNo) => {
    const res = await getData(`dbms/branchs/${BranchNo}/zones`)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const getCatalogs = async () => {
    const res = await getData(`dbms/itemcatalogs`)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const getMaterialsList = async () => {
    const res = await getData('dbms/materials')
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const getItemMasterList = async (ItemNo) => {
    let _params = '?limit=0';
    if (ItemNo) {
        _params = '?name=' + ItemNo + '&limit=0'

    }
    const res = await getData('dbms/items' + _params)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }

}
export const getDiscardItemMasterList = async (ItemNo) => {
    let _params = '?limit=0';
    if (ItemNo) {
        _params = '?name=' + ItemNo + '&limit=0'

    }
    const res = await getData('dbms/discard-items' + _params)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }

}
export const getItemDiscardBalanceList = async (branchNo) => {
    let _params = `${branchNo ? '?branchNo=' + branchNo : ''}`

    const res = await getData('discard-seed/balance' + _params)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }

}
export const getItemRawBalanceList = async (branchNo) => {
    let _params = `${branchNo ? '?branchNo=' + branchNo : ''}`

    const res = await getData('raw-seed/balance' + _params)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }

}

export const getRawSeedMovementsList = async (q, b, page, rowsPerPage) => {
    let _params = `${q ? '&receiveNo=' + q : ''}${b ? b !== 'all' ? '&branchNo=' + b : '' : ''}`
    const res = await getData(`raw-seed/movements?page=${page}&limit=${rowsPerPage}` + _params)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}

export const addRawSeed = async (body) => {
    const res = await postData(`raw-seed/movements`, body)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const updateRawSeed = async (body) => {
    const res = await putData(`raw-seed/movements/${body?.documentNo}`, body)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const detailRawSeed = async (documentNo) => {
    const res = await getData(`raw-seed/movements/${documentNo}`)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const getDiscardSeedMovementsList = async (q, b, t, page, rowsPerPage) => {
    let _params = `${q ? '&receiveNo=' + q : ''}${b ? b !== 'all' ? '&branchNo=' + b : '' : ''}${t ? t !== 'all' ? '&documentType=' + t : '' : ''}`
    const res = await getData(`discard-seed/movements?page=${page}&limit=${rowsPerPage}` + _params)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}

export const addDiscardSeed = async (body) => {
    const res = await postData(`discard-seed/movements`, body)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const updateDiscardSeed = async (body) => {
    const res = await putData(`discard-seed/movements/${body?.documentNo}`, body)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const detailDiscardSeed = async (documentNo) => {
    const res = await getData(`discard-seed/movements/${documentNo}`)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const getStockReceiveList = async (q, b, page, rowsPerPage) => {
    let _params = `${q ? '&receiveNo=' + q : ''}${b ? b !== 'all' ? '&branchNo=' + b : '' : ''}`
    const res = await getData(`stock/receives?page=${page}&limit=${rowsPerPage}` + _params)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}

export const addReceives = async (body) => {
    const res = await postData(`stock/receives`, body)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const updateReceives = async (body) => {
    const res = await putData(`stock/receives/${body?.ReceiveNo}`, body)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const detailReceives = async (ReceiveNo) => {
    const res = await getData(`stock/receives/${ReceiveNo}`)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}

export const getStockTransferList = async (q,FromBranchNo, ToBranchNo, page, rowsPerPage) => {
    let _params = `${q ? '&transferNo=' + q : ''}` + `${FromBranchNo ? '&fromBranchNo=' + FromBranchNo : ''}` + `${ToBranchNo ? '&toBranchNo=' + ToBranchNo : ''}`
    const res = await getData(`stock/transfers?page=${page}&limit=${rowsPerPage}` + _params)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}

export const getReservesSeedAllBranchList = async (q, c, page, rowsPerPage) => {
    let _params = `?${q ? 'q=' + q + '&' : ''}${c ? c !== 'all' ? 'catalogNo=' + c : '' : ''}`

    const res = await getData(`stock/non-center/reserves?page=${page}&limit=${rowsPerPage}` + _params)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const getReservesSeedList = async (q, c, page, rowsPerPage) => {
    let _params = `${q ? '&q=' + q : ''}${c ? c !== 'all' ? '&catalogNo=' + c : '' : ''}`

    const res = await getData(`stock/reserves?page=${page}&limit=${rowsPerPage}` + _params)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}

export const addReserve = async (body) => {
    const res = await postData(`stock/reserves`, body)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const updateReserve = async (body) => {
    const res = await putData(`stock/reserves/${body?.ReserveNo}`, body)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}

export const getReservesCenterList = async (q, c, page, rowsPerPage) => {
    let _params = `${q ? '&q=' + q : ''}${c ? c !== 'all' ? '&catalogNo=' + c : '' : ''}`

    const res = await getData(`stock/center/reserves?page=${page}&limit=${rowsPerPage}` + _params)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}


export const getAdjustsList = async (q, b, page, rowsPerPage) => {
    let _params = `${q ? '&q=' + q : ''}${b ? b !== 'all' ? '&branchNo=' + b : '' : ''}`

    const res = await getData(`stock/adjusts?page=${page}&limit=${rowsPerPage}` + _params)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const getLatestLot = async (prefix) => {
    let _params =  '?prefix=' + prefix

    const res = await getData(`stock/latestLot` + _params)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}